/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncInstallmentDetailPayloadDto
 */
export interface SyncInstallmentDetailPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof SyncInstallmentDetailPayloadDto
     */
    premiumScheduleId?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncInstallmentDetailPayloadDto
     */
    installmentNumber: number;
    /**
     * 
     * @type {number}
     * @memberof SyncInstallmentDetailPayloadDto
     */
    installmentPercent: number;
    /**
     * 
     * @type {Date}
     * @memberof SyncInstallmentDetailPayloadDto
     */
    dueDate: Date;
    /**
     * 
     * @type {number}
     * @memberof SyncInstallmentDetailPayloadDto
     */
    declarationId?: number;
}

/**
 * Check if a given object implements the SyncInstallmentDetailPayloadDto interface.
 */
export function instanceOfSyncInstallmentDetailPayloadDto(value: object): value is SyncInstallmentDetailPayloadDto {
    if (!('installmentNumber' in value) || value['installmentNumber'] === undefined) return false;
    if (!('installmentPercent' in value) || value['installmentPercent'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    return true;
}

export function SyncInstallmentDetailPayloadDtoFromJSON(json: any): SyncInstallmentDetailPayloadDto {
    return SyncInstallmentDetailPayloadDtoFromJSONTyped(json, false);
}

export function SyncInstallmentDetailPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncInstallmentDetailPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumScheduleId': json['premiumScheduleId'] == null ? undefined : json['premiumScheduleId'],
        'installmentNumber': json['installmentNumber'],
        'installmentPercent': json['installmentPercent'],
        'dueDate': (new Date(json['dueDate'])),
        'declarationId': json['declarationId'] == null ? undefined : json['declarationId'],
    };
}

export function SyncInstallmentDetailPayloadDtoToJSON(json: any): SyncInstallmentDetailPayloadDto {
    return SyncInstallmentDetailPayloadDtoToJSONTyped(json, false);
}

export function SyncInstallmentDetailPayloadDtoToJSONTyped(value?: SyncInstallmentDetailPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumScheduleId': value['premiumScheduleId'],
        'installmentNumber': value['installmentNumber'],
        'installmentPercent': value['installmentPercent'],
        'dueDate': ((value['dueDate']).toISOString()),
        'declarationId': value['declarationId'],
    };
}

